var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg004Company(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 21V9l9-4 9 4v12H3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21v-4h6v4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10h6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14h6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg004Company);
export default __webpack_public_path__ + "static/media/004-company.c7a2b7772ee411ed466e884e3cfde2c8.svg";
export { ForwardRef as ReactComponent };